// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getProgressiveIndexTypes } from "../../../api";

export const useProgressiveIndexTypes = () => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<string>>({
    queryKey: ["progressive-indextypes"],
    queryFn: async () => {
      const token = await getToken();
      return getProgressiveIndexTypes(token);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
